import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { SignInComponent } from './sign-in.component';
export var SignInComponentNgModule = module(baseModuleId + ".sign-in", [])
    .component('signIn', SignInComponent);
